import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [config, setConfig] = useState({ google_enabled: false, dev_mode: false });

  async function refresh() {
    const token = localStorage.getItem("nia_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("nia_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    api.get("/auth/config").then(({ data }) => setConfig(data)).catch(() => {});
    refresh();
  }, []);

  const login = (token, u) => {
    localStorage.setItem("nia_token", token);
    setUser(u);
  };

  const logout = () => {
    localStorage.removeItem("nia_token");
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, loading, config, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
